import React, { useContext } from "react";
import { useLocalStorage } from "@rehooks/local-storage";

export const AppContext = React.createContext();
export const useAppContext = () => useContext(AppContext);

export const AppProvider = (props) => {
  const [isProd, setIsProd] = useLocalStorage("isProd", true);

  const toggleEnv = () => {
    setIsProd(!isProd);
  };

  return (
    <AppContext.Provider
      value={{
        isProd,
        toggleEnv,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};
